import { createTranslations } from '@npco/utils-translations'

export const errorStateTranslations = createTranslations({
  title: 'Something Went Wrong',
  description:
    "We couldn't load the page due to an unexpected error. If the problem persists, please contact the Zeller Customer Success Team.",
  reload: 'Reload Page',
})
